import { BasicField } from '~shared/types'

export const NON_RESPONSE_FIELD_SET = new Set([
  BasicField.Section,
  BasicField.Statement,
  BasicField.Image,
])
